import SelectDropdown from './SelectDropdown';

interface RowsPerPageSelectProps {
  rowsPerPage: number;
  onChange: (rows: number) => void;
  options?: number[];
}

const RowsPerPageSelect = ({
  rowsPerPage,
  onChange,
  options = [10, 25, 50, 100],
}: RowsPerPageSelectProps) => {
  return (
    <div className="flex items-center justify-between sm:justify-start gap-4 text-sm">
      <span className="text-muted-foreground">Rows per page</span>

      <SelectDropdown
        value={String(rowsPerPage)}
        onChange={(value) => onChange(Number(value))}
        options={options.map((n) => ({
          label: String(n),
          value: String(n),
        }))}
        placeholder="Select rows"
        triggerClassName="h-9 w-[90px]"
      />
    </div>
  );
};

export default RowsPerPageSelect;
